import React from 'react';
import './me.scss';
import avatar from '../../assets/avatar.jpg'

function Me() {
    return(
        <div className="social-nav">
            <div className="row">
                <div className="col-12 d-flex justify-content-center main-image">
                    <img src={ avatar } className="rounded-circle shadow" alt=""/>
                </div>
            </div>
            <div className="row d-flex justify-content-center">
                <h1>Javier Alejandro Camacho Cuéllar</h1>
            </div>
            <hr/>
            <div className="row d-flex justify-content-center">
                <h2 className="text-white">Web Developer</h2>
            </div>
            <div className="row d-flex justify-content-center">
                <div className="hexagon3">

                </div>
            </div>
        </div>
    )
}

export default Me;